module.exports = __webpack_public_path__ + "AdobeStock_285202108_panel_iconcolors.svg?ffedef331b277cdd90f16450349f9189";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_285202108_panel_iconcolors.svg
// module id = 330
// module chunks = 0